export const getFromStorage = (key) => {
  return sessionStorage.getItem(key) || localStorage.getItem(key)
}
